import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import volume from '../assets/images/half-volume-yellow.png';
import soundwaves from '../assets/images/soundwaves.png';
import Modal from '../components/modal';
import { useTestState } from '../context/TestContext';
import useTracking from '../hooks/useTracking';

const Instructions = () => {
  const [tracked, setTracked] = useState(false);
  const [modal, setModal] = useState(false);
  const { state, dispatch } = useTestState();
  const navigate = useNavigate();
  const { t } = useTranslation('instructions');
  const { trackEvent } = useTracking();

  useEffect(() => {
    if (!state.contactid) {
      return navigate('/demographics');
    }
    if (!state.headphonesCheckPassed) {
      return navigate('/headphones');
    }
  }, [navigate, state.contactid, state.headphonesCheckPassed]);

  useEffect(() => {
    if (!tracked && state.email) {
      trackEvent('JHT_TRAINING_START');
      setTracked(true);
    }
  }, [state.email, trackEvent, tracked]);

  useEffect(() => {
    dispatch({ type: 'UPDATE_PROGRESS', payload: 100 });
  }, [dispatch]);

  const handleContinue = () => {
    setModal(true);
  };

  return (
    <div className="instructions">
      {modal && (
        <Modal closeModal={() => setModal(false)}>
          <div className="volume-container">
            <img
              src={volume}
              alt={t('half-volume-alt')}
              style={{ transform: 'scale(1.2)', marginBottom: '20px' }}
            />
          </div>
          <p
            className="device-modal-text"
            style={{ fontSize: '20px', lineHeight: '37px' }}
          >
            <strong>{t('do-not')}</strong> {t('adjust-volume-message')}
          </p>
          <Link
            className="link-button"
            to="/test"
            onClick={() => handleContinue()}
          >
            {t('continue')}
          </Link>
        </Modal>
      )}
      <h1 className="top-title-text">{t('top-title')}</h1>
      <div className="main-content">
        <p className="body-text">{t('body-text')}</p>
        <button className="link-button" onClick={() => handleContinue()}>
          {t('start-training')}
        </button>
        <img
          className="soundwaves"
          src={soundwaves}
          alt={t('sound-waves-alt')}
        />
      </div>
    </div>
  );
};

export default Instructions;
